import Link from 'next/link';
import type { BannerSection as BannerSectionType } from '@shared/lib/page-sections/types';

export default function BannerSection({ section }: { section: BannerSectionType }) {
  const bg = section.background || 'bg-emerald-600';
  const text = section.textColor || 'text-white';
  return (
    <section className={`w-full ${bg} ${text}`}>
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-3 text-center sm:flex-row sm:text-left">
        <p className="text-sm font-semibold">{section.text}</p>
        {section.ctaLabel && section.ctaHref ? (
          <Link
            href={section.ctaHref}
            className="text-sm font-semibold underline-offset-4 hover:underline"
          >
            {section.ctaLabel}
          </Link>
        ) : null}
      </div>
    </section>
  );
}
